import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("智能选品")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("手动定制")
const _hoisted_10 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "mx-auto mw-600px"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "pb-10 pb-lg-15" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label mb-5" }, "选择投放策略", -1)
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_18 = { class: "d-flex align-items-center me-2" }
const _hoisted_19 = { class: "symbol symbol-50px me-6" }
const _hoisted_20 = { class: "symbol-label" }
const _hoisted_21 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "智能排序"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400" })
], -1)
const _hoisted_23 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_24 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_25 = { class: "d-flex align-items-center me-2" }
const _hoisted_26 = { class: "symbol symbol-50px me-6" }
const _hoisted_27 = { class: "symbol-label" }
const _hoisted_28 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "规则"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400" })
], -1)
const _hoisted_30 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_31 = {
  key: 0,
  class: "fv-row mb-5"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label" }, "排序规则", -1)
const _hoisted_33 = { class: "fv-row mb-5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label" }, "更新周期", -1)
const _hoisted_35 = { key: 4 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("强制推广")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("柔性推广")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("上一步")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("下一步")

import { ref, reactive, onMounted, watch } from "vue";
import Datatable from "@/components/kt-datatable/Datatable2.vue";
import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import SelectionRule from "@/components/selection-item/SelectionRule.vue";
import EnterGoodsId from "@/components/selection-item/EnterGoodsId.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const dataT = ref<HTMLElement | null>(null);
const apiUrl= 'programme';
const tableHeader = ref([
  { name: "ID", key: "id"},
  { name: "方案名称", key: "name", sortable: true },
  { name: "国家", key: "country_name", sortable: true },
  { name: "选品类型", key: "selection_type_name", sortable: true },
  { name: "选品数量", key: "goods_count", sortable: true },
  // { name: "平均售价", key: "avg_price" },
  // { name: "平均折扣率", key: "avg_discount_rate" },
  { name: "维护人", key: "user" },
  { name: "创建时间", key: "create_time", sortable: true, sortingField: "-create_time" },
  { name: "更新时间", key: "update_time", sortable: true },
]);
const filters = reactive({
  search: '',
  is_active: 1,
  user_id: route.name == 'selection.my' ? store.getters.currentUser.id : 0,
});
const formData = reactive({
  id: 0,
  name: '',
  country_name: '',
  goods_count: 1000,  // 选品数量
  goods_sorting_key_id: '',  // 商品排序值id
  category_id: [] as any[],  // 类目id
  dimension: [] as any[],  // 用于组装Tree控件中的选中数据
  rules: [] as any[],  // 维度属性
  rule_type: 2,  // 规则排序类型, 1:个性化; 2:规则; 0:手动
  rule_sorting_key: '',  // 规则排序值，原始排序为n，自定义排序为c, n:2; c:2
  update_frequency: 1,  // 频率, 1:天; 2:周; 3:月; 0:手动
  black_input_type: 1,  // 黑名单手工输入方式, 1:直接输入；2:文件导入
  black: [] as any[],  // 黑名单商品
  topping_type: 1,  // 置顶类型, 1:强制推广; 2:柔性推广
  topping_input_type: 1,  // 置顶手工输入方式, 1:直接输入；2:文件导入
  topping: [] as any[],  // 置顶商品
  selection_type: 1,  // 选品类型, 1:智能选品; 2:手动定制
  input_type: 1,  // 手工输入方式, 1:直接输入; 2:文件导入
  goods: [] as any[],  // 手动指定商品
});
const rules = {
  name: [
      { required: true, message: '请输入方案名称', trigger: 'blur' }
  ],
  country_name: [
      { required: true, message: '请选择国家区域', trigger: 'change' }
  ],
}

const step = ref(1);  //步骤
const maxStep = ref(4);  //最多步骤
const config = reactive({
  area: [] as any[],  //站点区域配置
  category: [] as any[],  //站点类目配置
  dimension: [] as any[],  //站点维度配置
  attrs: {} as any,  //站点维度属性配置
  goods_sorting_key: [] as any[],  //站点选品排序
  rule_sorting_key: [] as any[],  //站点投放策略规则
  users: [] as any[],  //维护人列表
});
const defaultExpanded = ref<any>([]); //默认展开的节点
const loading = ref(false);  //载入状态

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("selection.programme", ["selection.name"]);

  loading.value = true;
  (dataT as any).value.btnLoading = true;
  ApiService.get('programme/config').then(({data}) => {
    if (data.area.length < 1) {
      ElMessage.error('模块未开通或基础数据不足，请与管理员联系！');
    } else {
      config.area = [...data.area];
      config.rule_sorting_key = [...data.rule_sorting_key];
      config.goods_sorting_key = [...data.goods_sorting_key];
      config.users = [...data.users];
      loading.value = false;
      (dataT as any).value.btnLoading = false;
    }
  })
});

const loadDimension = function() {
  if (config.category.length < 1 || config.dimension.length < 1 || Object.keys(config.attrs).length < 1){
    let _categoryTree = (category) => {
      let tree: Array<any> = []
      for (let c of category) {
        let t = {
          label: c.category_name,
          value: c.category_id,
        }
        if (c.children) {
          t['children'] = _categoryTree(c.children)
        }
        tree.push(t)
      }
      return tree
    }
    ApiService.get(apiUrl + '/dimension').then(({data}) => {
      if (data.category.length < 1 || data.dimension.length < 1 || Object.keys(data.attrs).length < 1) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else {
        let categoryTree: Array<any>  = _categoryTree(data.category);
        config.category = [...categoryTree];

        let treeData: Array<any> = []
        for (let d of data.dimension) {
          let children: Array<any> = []
          for (let c of d.children) {
            children.push({
              id: c.dimension_id + ':' + c.dimension_name + ':' + c.dimension_field + ':' + c.cat_id + ':' + c.cat_name + ':' + c.dtype,
              label: c.dimension_name,
            })
          }
          treeData.push({
            id: d.cat_id,
            label: d.cat_name,
            disabled: true,
            children: children
          })
        }
        config.dimension = [...treeData];
        config.attrs = data.attrs;
        if (defaultExpanded.value.length < 1) defaultExpanded.value.push(config.dimension[0].id)
      }
    });
  } else {
    if (defaultExpanded.value.length < 1) defaultExpanded.value.push(config.dimension[0].id)
  }
}

watch(route, (r) => {
  if (r.name == 'selection.my'){
    filters.search = '';
    filters.user_id = store.getters.currentUser.id;
    if ((dataT as any) != undefined) (dataT as any).value.setCurrent(1);
  } else {
    filters.search = '';
    filters.user_id = 0;
    if ((dataT as any) != undefined) (dataT as any).value.setCurrent(1);
  }
});

// 导出
const toExcel = () => {
  (dataT as any).value.toExcel([
    'id', 'name', 'site_name', 'country_name', 'goods_count', 'category_name', 'rule_name', 'frequency_name',
    'create_time', 'update_time'
  ], '选品方案数据')
};

const add = function() {
  step.value = 1;
  formData.country_name = config.area[0].name
  formData.goods_sorting_key_id = config.goods_sorting_key[0].key_id
  formData.rule_sorting_key = config.rule_sorting_key[0].key_type + ':' + config.rule_sorting_key[0].key_id
  defaultExpanded.value = []
  loadDimension();
};

const edit = function(item) {
  step.value = 1;
  formData.rule_sorting_key = item.rule_sorting_type + ':' + item.rule_sorting_key_id;
  let category_id = item.category_id.split(',');
  formData.category_id = [];
  for (let i in category_id ) {
    formData.category_id.push(parseInt(category_id[i]))
  }

  formData.rules = item.detail
  for (let r of formData.rules) {
    if (r.dselect === 'custom') r.dvalue = r.dvalue.join(',');
  }
  formData.dimension = []
  defaultExpanded.value = []
  for (let d of item.detail) {
    formData.dimension.push(d.dimension_id + ':' + d.dimension_name + ':' + d.dimension_field + ':' + d.cat_id + ':' + d.cat_name + ':' + d.dtype);
    defaultExpanded.value.push(d.cat_id)
  }
  let goods_type = '1,2';
  if (item.selection_type === 2 && item.input_type === 1)
    goods_type += ',3';
  ApiService.get(apiUrl + '/goods', {programme_id: item.id, goods_type: goods_type, limit: 3000}).then(({data}) => {
    let topping = [] as any[], black = [] as any[], goods = [] as any[];
    for (let g of data.results) {
      if (g.goods_type === 1)
        topping.push(g)
      else if (g.goods_type === 2)
        black.push(g)
      else
        goods.push(g)
    }
    formData.topping = topping;
    formData.black = black;
    formData.goods = goods;
  });
  loadDimension();
};

// 复制
const copy = function(item) {
  ElMessageBox.prompt(item.name+' 复制为', '复制选品方案', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputValue: item.name,
    inputValidator: function(value: string): boolean {
      return !(value == null || value == '');
    },
    inputErrorMessage: '方案名称不能为空',
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true
        // instance.confirmButtonText = 'Loading...'
        ApiService.post(apiUrl + '/copy/'+item.id, {name: instance.inputValue}).then(() => {
          done()
          instance.confirmButtonLoading = false;
          (dataT as any).value.setCurrent(1)
        }).catch(() => {
          instance.confirmButtonLoading = false
        });
      } else {
        done()
      }
    },
  }).catch(() => {});
};

// 恢复
const recover = function(item) {
  ApiService.patch(apiUrl + '/recover/' + item.id, {is_active: true}).then((res) => {
    ElMessage.success("恢复成功！");
    // filters.is_active = 1;
    (dataT as any).value.setCurrent(1);
  });
}

// 下一步
const onStep = function() {
  //第一步参数检查
  if (step.value == 1 && formData.name == '') {
    ElMessage.error("请先填写必要参数！")
  //系统参数检查
  } else if (step.value == 1 && config.category.length < 1 || config.dimension.length < 1 || Object.keys(config.attrs).length < 1) {
    ElMessage.error("您的网络环境不太好，载入过慢，请重新刷新！")
  //第二步参数检查
  } else if (step.value == 2 && formData.selection_type === 1 && (formData.dimension.length == 0 || formData.category_id.length == 0)) {
    ElMessage.error("请选择维度指标和类目！")
  } else if (step.value == 2 && formData.selection_type === 2 && (formData.input_type == 1 || formData.id == 0) && formData.goods.length == 0) {
    ElMessage.error("请输入商品id！")
  //第三步参数检查
  } else if (step.value == 3 && formData.rule_type == 2 && formData.rule_sorting_key == '') {
    ElMessage.error("请选择排序规则！")
  } else {
    step.value += 1;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    "enable-items-per-page-dropdown": true,
    data: _unref(formData),
    rules: rules,
    filters: _unref(filters),
    title: "选品方案",
    step: step.value,
    maxStep: maxStep.value,
    addAction: add,
    editAction: edit,
    delete: false
  }, _createSlots({
    "search-back": _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_radio_group, {
        modelValue: _unref(filters).is_active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).is_active) = $event)),
        size: "small",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (dataT.value.setCurrent(1)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: 1 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: 0 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_4,
      (_unref(route).name !== 'selection.my')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: _unref(filters).user_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).user_id) = $event)),
            size: "small",
            placeholder: "请选择维护人",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (dataT.value.setCurrent(1))),
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_el_option, {
                value: 0,
                key: 0,
                label: "所有维护人"
              })),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).users, (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  value: v.id,
                  key: v.id,
                  label: v.username
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    "add-back": _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-document",
        size: "small",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (toExcel())),
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    "cell-name": _withCtx(({ row: r }) => [
      _createVNode(_component_router_link, {
        target: "_blank",
        to: {name: 'selection.view', params: {id: r.id}},
        class: "text-gray-600"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(r.name), 1)
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-user": _withCtx(({ row: r }) => [
      _createTextVNode(_toDisplayString(r.user.username), 1)
    ]),
    form: _withCtx(() => [
      _createVNode(_component_el_steps, {
        active: step.value - 1,
        "finish-status": "success",
        "align-center": "",
        style: {"margin-bottom":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, { title: "方案详情" }),
          _createVNode(_component_el_step, { title: "选品策略" }),
          _createVNode(_component_el_step, { title: "投放策略" }),
          _createVNode(_component_el_step, { title: "运营策略" })
        ]),
        _: 1
      }, 8, ["active"]),
      (step.value===1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_form_item, {
              label: "方案名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).name) = $event)),
                  placeholder: "请输入选择方案名称",
                  size: "small",
                  style: {"width":"300px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "国家区域",
              prop: "country_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(formData).country_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).country_name) = $event)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).area, (v) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: v.name,
                        label: v.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "选品类型",
              prop: "selection_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(formData).selection_type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).selection_type) = $event)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_unref(formData).selection_type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "选品数量",
                  prop: "goods_count"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(formData).goods_count,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).goods_count) = $event)),
                      modelModifiers: { number: true },
                      placeholder: "请填写数字",
                      "controls-position": "right",
                      min: 1,
                      max: 3000,
                      size: "small",
                      style: {"width":"300px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(formData).selection_type === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "选品排序",
                  prop: "goods_sorting_key_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(formData).goods_sorting_key_id,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).goods_sorting_key_id) = $event)),
                      placeholder: "请选择选品的排序规则",
                      size: "small",
                      style: {"width":"300px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).goods_sorting_key, (v) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: v.key_id,
                            key: v.key_id,
                            label: v.key_name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (step.value===2 && _unref(formData).selection_type === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(SelectionRule, {
              apiUrl: apiUrl,
              config: _unref(config),
              data: _unref(formData),
              defaultExpanded: defaultExpanded.value,
              "category-enable": true
            }, null, 8, ["config", "data", "defaultExpanded"])
          ]))
        : _createCommentVNode("", true),
      (step.value===2 && _unref(formData).selection_type===2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(EnterGoodsId, {
              apiUrl: apiUrl,
              data: _unref(formData),
              autoUpload: true
            }, null, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      (step.value===3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin001.svg" })
                          ])
                        ])
                      ]),
                      _hoisted_22
                    ]),
                    _createElementVNode("span", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "rule_type",
                        value: 1,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).rule_type) = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(formData).rule_type]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra006.svg" })
                          ])
                        ])
                      ]),
                      _hoisted_29
                    ]),
                    _createElementVNode("span", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "rule_type",
                        value: 2,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).rule_type) = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(formData).rule_type]
                      ])
                    ])
                  ])
                ])
              ]),
              (_unref(formData).rule_type === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_el_select, {
                      modelValue: _unref(formData).rule_sorting_key,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).rule_sorting_key) = $event)),
                      style: {"width":"300px","padding":"0","margin-left":"40px"},
                      placeholder: "请选择排序规则"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).rule_sorting_key, (v) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: v.key_type + ':' + v.key_id,
                            key: v.key_id,
                            label: v.key_name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).update_frequency,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).update_frequency) = $event)),
                  style: {"width":"300px","padding":"0","margin-left":"40px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "天"
                    }),
                    _createVNode(_component_el_option, {
                      value: 2,
                      label: "周"
                    }),
                    _createVNode(_component_el_option, {
                      value: 3,
                      label: "月"
                    }),
                    _createVNode(_component_el_option, {
                      value: 0,
                      label: "自定义"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value===4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(_component_el_form_item, {
              label: "置顶类型",
              prop: "topping_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(formData).topping_type,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).topping_type) = $event)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(EnterGoodsId, {
              apiUrl: apiUrl,
              data: _unref(formData),
              name: "置顶商品",
              autoUpload: true,
              field_input_type: "topping_input_type",
              field_goods: "topping",
              input_text: true
            }, null, 8, ["data"]),
            _hoisted_38,
            _createVNode(EnterGoodsId, {
              apiUrl: apiUrl,
              data: _unref(formData),
              name: "黑名单商品",
              autoUpload: true,
              field_input_type: "black_input_type",
              field_goods: "black",
              input_text: true
            }, null, 8, ["data"])
          ]))
        : _createCommentVNode("", true)
    ]),
    btn: _withCtx(() => [
      (step.value > 1)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (step.value -= 1))
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (step.value < maxStep.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (onStep()))
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_unref(filters).is_active === 1)
      ? {
          name: "actions-front",
          fn: _withCtx(({ row: r }) => [
            _createVNode(_component_router_link, {
              target: "_blank",
              to: {name: 'selection.view', params: {id: r.id}},
              title: "查看结果",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"]),
            _createVNode(_component_el_button, {
              icon: "el-icon-document-copy",
              size: "small",
              onClick: ($event: any) => (copy(r)),
              title: "复制",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, null, 8, ["onClick"])
          ])
        }
      : {
          name: "actions",
          fn: _withCtx(({ row: r }) => [
            _createVNode(_component_router_link, {
              target: "_blank",
              to: {name: 'selection.view', params: {id: r.id}},
              title: "查看结果",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"]),
            _createVNode(_component_el_button, {
              icon: "el-icon-refresh-left",
              size: "small",
              onClick: ($event: any) => (recover(r)),
              title: "恢复",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, null, 8, ["onClick"])
          ])
        }
  ]), 1032, ["table-header", "data", "filters", "step", "maxStep"]))
}
}

})